import { render, staticRenderFns } from "./Cashregisters.vue?vue&type=template&id=227fb60e&scoped=true"
import script from "./Cashregisters.vue?vue&type=script&lang=js"
export * from "./Cashregisters.vue?vue&type=script&lang=js"
import style0 from "./Cashregisters.vue?vue&type=style&index=0&id=227fb60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227fb60e",
  null
  
)

export default component.exports